import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages are pre-rendered at build time (react-snap) for search engines and first paint.
// react-snap snapshots a client-rendered DOM (adjacent text nodes are merged), which
// React 18 cannot hydrate without mismatch errors, so the app renders fresh instead.
// The markup is identical, so there is no visible change.
ReactDOM.createRoot(container).render(app);

// Send Core Web Vitals from real visitors to Google Analytics.
reportWebVitals(({ name, value, id }) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, {
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      metric_id: id,
      non_interaction: true
    });
  }
});
